<template>
	<TheLoader :isLoading="loading" />
	<div class="login-page">
		<div class="login-box">
			<div class="card card-outline card-primary">
				<div class="card-header text-center">
					<a href="#" class="h2">
						<img src="@/assets/images/logo-tpsd.png" class="brand-image img-circle elevation-3">&nbsp;<b>{{
							$t('labels.signIn') }}</b>
					</a>
				</div>
				<div class="card-body">
					<form @submit.prevent="onSubmit()">
						<!-- Tài khoản -->
						<div class="input-group mb-2">
							<input type="text" @blur="validateUserName()"
								:class="['form-control', { 'is-invalid': errors.userName }]"
								:placeholder="$t('labels.userName')" v-model="model.userName" />
							<div class="input-group-append">
								<span class="input-group-text"><i class="fas fa-user icon-append"></i></span>
							</div>
						</div>
						<div class="text-danger mb-2" v-if="errors.userName">{{ $t('labels.noticeUserName') }}</div>

						<!-- Mật khẩu -->
						<div class="input-group mb-2">
							<input v-if="showPassword" type="text" @blur="validatePassword()"
								:class="['form-control', { 'is-invalid': errors.password }]"
								:placeholder="$t('labels.password')" v-model="model.password" />
							<input v-else type="password" autocomplete="off" @blur="validatePassword()"
								:class="['form-control', { 'is-invalid': errors.password }]"
								:placeholder="$t('labels.password')" v-model="model.password" />
							<div class="input-group-append" @click="toggleShow">
								<span class="input-group-text" v-if="!showPassword"><i
										class="fa fa-eye icon-append"></i></span>
								<span class="input-group-text" v-else><i class="fa fa-eye-slash icon-append"></i></span>
							</div>
						</div>
						<div class="text-danger mb-2" v-if="errors.password">{{ $t('labels.noticePasword') }}</div>

						<!-- Ghi nhớ & Đăng nhập -->
						<div class="row">
							<div class="col-6">
								<!-- <div class="icheck-primary">
									<input type="checkbox" id="remember" v-model="model.savePassword">
									<label for="remember">Ghi nhớ</label>
								</div> -->
							</div>
							<div class="col-6">
								<button type="submit" :disabled="submitted" class="btn btn-primary btn-block">{{
									$t('labels.signIn') }}</button>
							</div>
						</div>
					</form>
					<!-- <p class="mb-1 mt-3 text-center"><a href="#">{{ $t('labels.forgotPassword') }}</a></p>
					<p class="mb-0 text-center"><a href="#" class="text-center">{{ $t('labels.registerMembership') }}</a></p> -->
				</div>
				<p class="mt-1 mb-3 text-muted text-center">
					<strong>
						<a href="#">
							<img src="@/assets/images/logo-tpsd.png" class="brand-image img-circle elevation-3">
							UBND Thành phố Sa Đéc
						</a>
					</strong>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '@/config/prod.env';
import router from '@/router/index.js';
export default {
	name: 'TheLogin',
	data() {
		return {
			errors: {
				userName: '',
				password: ''
			},
			model: {
				userName: '',
				password: '',
				appId: '',
			},
			showPassword: false,
			submitted: false,
			loading: false,
		};
	},
	methods: {
		...mapActions('authentication', ['login', 'logout']),
		validate() {
			let isValid = true;
			this.errors = {
				userName: '',
				password: ''
			};
			if (!this.model.userName) {
				this.errors.userName = 'Vui lòng nhập tài khoản';
				isValid = false;
			}
			if (!this.model.password) {
				this.errors.password = 'Vui lòng nhập mật khẩu';
				isValid = false;
			}
			return isValid;
		},
		validateUserName() {
			let isValid = true;
			this.errors = {
				userName: ''
			};
			if (!this.model.userName) {
				this.errors.userName = 'Vui lòng nhập tài khoản';
				isValid = false;
			}
			return isValid;
		},
		validatePassword() {
			let isValid = true;
			this.errors = {
				password: ''
			};
			if (!this.model.password) {
				this.errors.password = 'Vui lòng nhập tài khoản';
				isValid = false;
			}
			return isValid;
		},
		async onSubmit() {
			this.submitted = true;
			this.loading = true;
			this.model.appId = this.$route.query.appId
			if (await this.validate()) {
				let userName = this.model.userName;
				let password = this.model.password;
				let appId = this.model.appId == undefined ? config.APPID : this.model.appId;

				await this.login({ userName, password, appId });
			}
			this.submitted = false;
			this.loading = false;
		},
		onLogout() {
			this.logout()
		},
		onReset(e) {
			e.preventDefault();
			this.model.userName = '';
			this.model.password = '';
		},
		toggleShow() {
			this.showPassword = !this.showPassword;
		}
	},
	created() {
		// let error = this.$route.query.error
		// let user = JSON.parse(localStorage.getItem('user'));
		// if (user && Date.parse(user.expiresTime) > Date.now()) {
		// 	//Đã đăng nhập và còn thời gian
		// 	let appId = this.$route.query.appId
		// 	if (appId == undefined || appId == config.API_URL) {
		// 		router.push({ path: '/dashboard' });
		// 	}
		// 	// else {
		// 	// 	let appInfo = user.appInfo.filter(e => e.appId == appId)[0] ? user.appInfo.filter(e => e.appId == appId)[0] : null
		// 	// 	if (appInfo) {
		// 	// 		window.location.href = appInfo.appDomain + '/?login=' + user.loginInfoId
		// 	// 	}
		// 	// 	else {
		// 	// 		localStorage.removeItem('user');
		// 	// 		localStorage.removeItem('menu');
		// 	// 		this.$store.dispatch("alert/error", "Tài khoản hiện tại không thể đăng nhập vào hệ thống này. Mời đăng nhập lại!", { root: true });
		// 	// 	}
		// 	// }
		// }
		// else {
		// 	if (user && Date.parse(user.expiresTime) <= Date.now()) {
		// 		// Đã đăng nhập và hết hạn
		// 	}
		// 	else {
		// 		//Chưa đăng nhập
		// 	}
		// }
	},

	async mounted() {
	}
}
</script>
<style scoped>
.icon-append {
	width: 20px;
}

.img-circle {
	opacity: .8;
	margin-top: -.5rem;
	margin-right: .2rem;
	height: 33px;
}
</style>